import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { SoftballPitchClockService } from '../pitch-clock.service';
import { ageToBand, requiredRestDays } from '../windmill-rest-rules';

@Component({
  selector: 'app-softball-live-scorer',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './softball-live-scorer.component.html',
  styleUrl: './softball-live-scorer.component.scss'
})
export class SoftballLiveScorerComponent {
  private readonly clock = inject(SoftballPitchClockService);

  readonly current = this.clock.current;

  readonly restWarning = computed(() => {
    const c = this.current();
    if (!c) return null;
    const band = ageToBand(14);
    const rest = requiredRestDays(band, c.pitches);
    return rest >= 2 ? `Rest required: ${rest} day${rest === 1 ? '' : 's'}` : null;
  });

  recordPitch(): void {
    this.clock.recordPitch();
  }

  startDemo(): void {
    this.clock.start('demo-game', 'demo-pitcher');
  }

  stop(): void {
    this.clock.stop();
  }
}
